export default __webpack_public_path__ + "static/media/atmospheric-impacts-of-combustion-emissions-sectors.41711591.png";